import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tokenStr: '',
    history: []
  },
  mutations: {
    SET_TOKEN: (state, data) => {
      state.tokenStr = data
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    tokenStrs (state) {
      console.log(state)
      return state.tokenStr
    },
    userTypes (state) {
      return state.userType
    }
  },
  plugins: [createPersistedState({
    reducer (val) {
      return {
        // 只储存state中的token
        tokenStrs: val.tokenStr
      }
    }
  })]
})
